export default "__VITE_ASSET__C$kTuQht__"